import { useEffect, useState } from "react";
import api, { API } from "../lib/api";

/**
 * AuthImage - loads an authenticated image as a blob URL.
 * Pass either a full src or fileId. Optional size: thumb|medium|full
 */
export const AuthImage = ({ fileId, src, alt, className, fallback, size }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    let revoked = false;
    let createdBlob = null;
    async function load() {
      if (!fileId && !src) return;
      try {
        if (src && !fileId) {
          setBlobUrl(src);
          return;
        }
        const url = size ? `/files/${fileId}?size=${size}` : `/files/${fileId}`;
        const resp = await api.get(url, { responseType: "blob" });
        if (!revoked) {
          createdBlob = URL.createObjectURL(resp.data);
          setBlobUrl(createdBlob);
        }
      } catch (e) {
        setErrored(true);
      }
    }
    load();
    return () => {
      revoked = true;
      if (createdBlob) URL.revokeObjectURL(createdBlob);
    };
  }, [fileId, src, size]);

  if (errored || !blobUrl) {
    return fallback || <div className={`bg-bone ${className || ""}`} />;
  }
  return <img src={blobUrl} alt={alt || ""} className={className} loading="lazy" />;
};

export default AuthImage;
